import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
  border-radius: 16px;
  width: 60vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  color: #303030;
  z-index: 1000;

  @media (max-width: 992px) {
    width: 80vw;
  }

  @media (max-width: 768px) {
    width: 90vw;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.8vh 1.2vw;
`;

export const HeaderTitle = styled.h2`
  font-size: 1.4vw;
  font-weight: 700;
  margin: 0;
  color: #303030;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const CloseButton = styled.button`
  width: 2.5vw;
  height: 2.5vw;
  min-width: 32px;
  min-height: 32px;
  border-radius: 50%;
  background-color: #eaeaea;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentContainer = styled.div`
  padding: 0vh 1.2vw;
  overflow-y: auto;
  flex: 1;
`;

interface FormGridProps {
    cols: number;
}

export const FormGrid = styled.div<FormGridProps>`
  display: grid;
  grid-template-columns: repeat(${props => props.cols}, 1fr);
  gap: 20px 30px;
  margin-bottom: 2vh;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #303030;
  margin-bottom: 8px;
  font-weight: bold;
`;

export const Input = styled.input`
  padding: 8px 15px;
  border: 1px solid #ddd;
  border-radius: 100px;
  font-size: 14px;
  background-color: #ebebeb;
  outline: none;
  height: 40px;
  width: 100%;
  box-sizing: border-box;
  color: #696969;

  &::placeholder {
    color: #999;
  }

  &:focus {
    border-color: #0090d3;
  }

  &:disabled {
    background-color: #c4c4c4;
    cursor: not-allowed;
  }
`;

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Select = styled.select`
  padding: 8px 15px;
  padding-right: 40px;
  border: 1px solid #ddd;
  border-radius: 100px;
  font-size: 14px;
  background-color: #ebebeb;
  outline: none;
  width: 100%;
  height: 40px;
  appearance: none;
  cursor: pointer;
  color: #696969;

  &:focus {
    border-color: #0090d3;
  }

  option {
    background-color: white;
    color: #333;
  }

  &:disabled {
    background-color: #c4c4c4;
    cursor: not-allowed;
  }
`;

export const SelectIcon = styled.div`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Section = styled.div`
  margin-bottom: 2vh;
`;

export const CausaPertinenteWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: flex-start;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const CausaWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const PertinenteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 120px;
  flex-shrink: 0;
  padding-left: 40px;

  @media (max-width: 768px) {
    align-items: flex-start;
    margin-top: 0;
    padding-left: 0;
  }
`;

export const ToggleSwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 34px;
  margin-top: 0px;
`;

export const ToggleSwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

interface ToggleSwitchSliderProps {
    checked: boolean;
}

export const ToggleSwitchSlider = styled.span<ToggleSwitchSliderProps>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.checked ? '#0090d3' : '#ccc'};
  transition: 0.4s;
  border-radius: 34px;
  border: ${props => props.checked ? 'none' : '2px solid #696969'};
`;

export const ToggleSwitchThumb = styled.span<ToggleSwitchSliderProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 24px;
  width: 24px;
  left: ${props => props.checked ? '17px' : '4px'};
  top: ${props => props.checked ? '3px' : '2.8px'};
  background-color: ${props => props.checked ? '#fff' : '#696969'};
  border-radius: 50%;
  transition: all 0.4s;
`;

export const ActionItemsSection = styled.div`
  margin-bottom: 2vh;
`;

export const ActionItemsHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 32px;
  gap: 10px;
  margin-bottom: 10px;
  padding-right: 10px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ActionItemRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 32px;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 12px;
    background-color: #f9f9f9;
    border-radius: 8px;
  }
`;

export const ResponsibleInputWrapper = styled.div`
  position: relative;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    align-self: flex-end;
  }
`;

export const AddButton = styled.button`
  background-color: transparent;
  color: #0090d3;
  border: none;
  padding: 12px 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 20px auto 0;
`;

export const AttachmentContainer = styled.div`
  padding: 8px 15px;
  border: 1px solid #ddd;
  border-radius: 100px;
  background-color: #ebebeb;
  min-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;

  span {
    color: #0090d3;
    font-size: 14px;
  }
`;

export const FileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background-color: #f5f5f5;
  border-radius: 8px;
  font-size: 13px;
  color: #303030;
`;

export const FileRemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #e74c3c;
  padding: 2px;
  display: flex;
  align-items: center;

  &:hover {
    color: #c0392b;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding: 2.5vh 1.2vw;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

export const CancelButton = styled.button`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
`;

export const SaveButton = styled.button`
  background-color: #0090d3;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
